import { SVGProps } from "react";

const STIStrava = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-label="Strava" role="img" viewBox="0 0 512 512" width="1em" height="1em" {...props}><rect width={512} height={512} rx="15%" fill="#fc4c01" /><path fill="#fff" d="M120 288L232 56l112 232h-72l-40-96-40 96z" /><path fill="#fda580" d="M280 288l32 72 32-72h48l-80 168-80-168z" /></svg>;

export { STIStrava };